import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import auth from '../../auth'
import LoginPresentation from '../../components/Login'
import { loginUser } from '../../actions'
import AuthenticationShell from 'shared/components/AuthenticationShell'
import Page from 'shared/components/Page'
import Title from 'shared/components/Title'
import * as R from 'ramda'
import { signedInLogCallBack } from './utils'

export default function Login() {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()

  const error = useSelector(
    ({
      pages: {
        login: { error },
      },
    }) => error
  )
  const loading = useSelector(
    ({
      pages: {
        login: { loading },
      },
    }) => loading
  )

  const [shouldSendError, setShouldSendError] = useState(true)
  const [availableLoginMethods, setAvailableLoginMethods] = useState(
    location?.state?.availableLoginMethods ?? []
  )
  const referer = R.path(['state', 'prev', 'pathname'], location) || '/'

  useEffect(() => {
    if (auth.isLoggedIn()) {
      history.replace(referer)
    }
  }, [history, referer])

  useEffect(() => {
    if (R.prop('ssoError', location.state)) {
      error.sso = true
    }
    if (R.prop('loginMethodError', location.state)) {
      if (!availableLoginMethods.length) {
        error.noLoginMethodAvailable = true
      }
    }
  }, [location, error.sso, error.noLoginMethodAvailable, availableLoginMethods.length])

  function doLogin(username, password) {
    setShouldSendError(false)
    return dispatch(loginUser(username, password)).then((authData) => {
      if (authData.requireSSO) {
        setShouldSendError(true)
      } else if (!authData.isAuthenticated && authData.availableLoginMethods) {
        if (authData.availableLoginMethods.length === 0) {
          setShouldSendError(true)
          error.noLoginMethodAvailable = true
        }
        setAvailableLoginMethods(authData.availableLoginMethods ?? [])
      } else if (authData.isAuthenticated && !authData.requireOtp) {
        history.replace({
          pathname: referer,
          search: location.search,
          state: signedInLogCallBack('username_password'),
        })
      } else if (authData.isAuthenticated && authData.requireOtp) {
        history.push({
          pathname: '/login/two-factor/',
          search: location.search + '&login_method=username_password',
          state: {
            token: authData.token,
            pathname: referer,
          },
        })
      } else {
        setShouldSendError(true)
      }
    })
  }

  return (
    <Page>
      <Title title="Login" />
      <AuthenticationShell
        headerText="Log in to your account"
        subHeaderText="Welcome back! Select a method to log in:"
      >
        <LoginPresentation
          onLogin={doLogin}
          error={shouldSendError ? error : null}
          availableLoginMethods={availableLoginMethods}
          search={location.search}
          loading={loading}
        />
      </AuthenticationShell>
    </Page>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Login/index.js